var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9887 3.14981C21.0715 2.60375 20.6959 2.09402 20.1498 2.01128L11.2514 0.663037C10.7053 0.580301 10.1956 0.955894 10.1128 1.50195C10.0301 2.048 10.4057 2.55773 10.9518 2.64047L18.8615 3.83891L17.663 11.7486C17.5803 12.2947 17.9559 12.8044 18.5019 12.8872C19.048 12.9699 19.5577 12.5943 19.6405 12.0482L20.9887 3.14981ZM1.5932 17.8051L20.5932 3.80506L19.4068 2.19494L0.406801 16.1949L1.5932 17.8051Z",
    fill: "#22370D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.c95462607792fb9a0eb5891d9a6385b0.svg";
export { ForwardRef as ReactComponent };